import { AppState } from '../root.reducer';

export const getGuarantorModal = (state: AppState) => {
  return state.guarantor.modal;
};
